export const AUTH_ERROR_MODAL = "AUTH_ERROR_MODAL";
export const AUTH_ALLOWED_DEVICE_FEATURES_SUCCESS = "AUTH_ALLOWED_DEVICE_FEATURES_SUCCESS";
export const AUTH_ALLOWED_DEVICE_FEATURES_FAILURE = "AUTH_ALLOWED_DEVICE_FEATURES_FAILURE";

export const UM_AUTHORIZE_REQUEST = "UM_AUTHORIZE_REQUEST";
export const UM_AUTHORIZE_SUCCESS = "UM_AUTHORIZE_SUCCESS";
export const UM_AUTHORIZE_FAILURE = "UM_AUTHORIZE_FAILURE";

export const UM_RESET_AUTHORIZE_FAILURE_STATUS = "UM_RESET_AUTHORIZE_FAILURE_STATUS";
